import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { TypeActionModal } from "../../modals/actionModal";
import { actionOngoingPurchaseCloseAll } from "../actionOngoingPurchase";
export var epicOngoingPurchaseCloseAll = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionModal.CloseAll), mapTo(actionOngoingPurchaseCloseAll()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/epics/epicOngoingPurchaseCloseAll.ts
// module id = 2034
// module chunks = 3